// src/components/ToolBox.jsx

import React from "react";
import { motion } from "framer-motion";
import { FaJava } from 'react-icons/fa';

import {
  SiReact,
  SiJavascript,
  SiPython,
  SiKotlin,
  SiPostgresql,
  SiMongodb,
  SiDocker,
  SiHtml5,
  SiCss3,
  SiTailwindcss,
  SiNodedotjs,
  SiFigma,
  SiFirebase,
  SiRedux,
  SiJira,
  SiJunit5,
  SiCicd,
  SiJson,
  SiSpringboot,
  SiPostman,

} from "react-icons/si";
import { FaTools } from "react-icons/fa"; 
import { MdSyncAlt } from "react-icons/md";
import { SiSpinnaker, SiSplunk } from 'react-icons/si';


const icons = [
  { name: "Python", icon: <SiPython /> },
  { icon: <FaJava />, name: 'Java' },
  { name: "Kotlin", icon: <SiKotlin /> },
  { name: "Spring Boot", icon: <SiSpringboot /> },
  { name: "JavaScript", icon: <SiJavascript /> },
  { name: "React", icon: <SiReact /> },
  { name: "REST APIs", icon: <SiPostman /> },
  { name: "JSON", icon: <SiJson /> },
  { name: "Regex", icon: <FaTools /> },
  { name: "CI/CD", icon: <MdSyncAlt /> },
  { name: "JUnit", icon: <SiJunit5 /> },
  { name: "Jira", icon: <SiJira /> },
  { name: "Internal Config Tools", icon: <FaTools /> },
  { icon: <SiDocker />, name: 'Docker' },
  { icon: <SiHtml5 />, name: 'HTML5' },
  { icon: <SiCss3 />, name: 'CSS3' },
   { icon: <SiSpinnaker />, name: "Spinnaker" },
  { icon: <SiSplunk />, name: "Splunk" },

];

const ToolBox = () => {
  return (
    <section className="bg-[#0D117] text-white pt-2 px-8 ">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl font-bold text-center mb-12 text-purple-400 flex items-center justify-center gap-4 -mt-7">
          <FaTools className="text-purple-400" /> Technologies Used
        </h2>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-8 place-items-center">
          {icons.map((icons, index) => (
            <div
              key={index}
              className="flex flex-col items-center space-y-2 hover:scale-110 transform transition duration-300"
            >
              <div className="text-4xl text-purple-300">{icons.icon}</div>
              <p className="text-sm text-gray-300 text-center">{icons.name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ToolBox;
